export default {
  // General styles for code blocks
  'pre[class*="language-"]': {
    color: '#F8F8F2', // Soft white text
    fontSize: '13px',
    textShadow: 'none',
    fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
    direction: 'ltr',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    borderRadius: '10px',
    wordBreak: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
    padding: '1em',
    margin: '0',
    overflow: 'auto',
    background: 'transparent', // Dark deep purple background
  },
  // General styles for inline code
  'code[class*="language-"]': {
    color: '#F8F8F2', // Soft white text
    fontSize: '13px',
    textShadow: 'none',
    fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
    direction: 'ltr',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
  },
  // Selection styles
  'pre[class*="language-"]::selection': {
    textShadow: 'none',
    background: '#44475A', // Muted selection background
  },
  'code[class*="language-"]::selection': {
    textShadow: 'none',
    background: '#44475A',
  },
  'pre[class*="language-"] *::selection': {
    textShadow: 'none',
    background: '#44475A',
  },
  'code[class*="language-"] *::selection': {
    textShadow: 'none',
    background: '#44475A',
  },
  // Inline code specific style
  ':not(pre) > code[class*="language-"]': {
    padding: '.1em .3em',
    borderRadius: '.3em',
    color: '#FF79C6', // Kawaii pink for inline code
    background: '#44475A', // Darker background for inline code
  },
  // Syntax Highlighting Rules
  '.namespace': {
    Opacity: '.7',
  },
  'doctype.doctype-tag': {
    color: '#FF79C6', // Pink
  },
  'doctype.name': {
    color: '#F1FA8C', // Yellow
  },
  comment: {
    color: '#6272A4', // Muted purple/grey
  },
  prolog: {
    color: '#6272A4', // Muted purple/grey
  },
  punctuation: {
    color: '#F8F8F2', // Soft white
  },
  property: {
    color: '#8BE9FD', // Cyan
  },
  tag: {
    color: '#FF79C6', // Pink
  },
  boolean: {
    color: '#BD93F9', // Purple
  },
  number: {
    color: '#BD93F9', // Purple
  },
  constant: {
    color: '#8BE9FD', // Cyan
  },
  symbol: {
    color: '#BD93F9', // Purple
  },
  inserted: {
    color: '#50FA7B', // Green
  },
  unit: {
    color: '#BD93F9', // Purple
  },
  selector: {
    color: '#FF79C6', // Pink
  },
  'attr-name': {
    color: '#50FA7B', // Green
  },
  string: {
    color: '#F1FA8C', // Yellow
  },
  char: {
    color: '#F1FA8C', // Yellow
  },
  builtin: {
    color: '#8BE9FD', // Cyan
  },
  deleted: {
    color: '#FF5555', // Red for deletions
  },
  '.language-css .token.string.url': {
    textDecoration: 'underline',
  },
  operator: {
    color: '#FF79C6', // Pink operators
  },
  entity: {
    color: '#F1FA8C', // Yellow
  },
  'operator.arrow': {
    color: '#FF79C6', // Pink
  },
  atrule: {
    color: '#FFB86C', // Orange
  },
  'atrule.rule': {
    color: '#FF79C6', // Pink
  },
  'atrule.url': {
    color: '#F1FA8C', // Yellow
    textDecoration: 'underline',
  },
  'atrule.url.function': {
    color: '#50FA7B', // Green
  },
  'atrule.url.punctuation': {
    color: '#F8F8F2', // Soft white
  },
  keyword: {
    color: '#FF79C6', // Pink
  },
  'keyword.module': {
    color: '#FF79C6', // Pink
  },
  'keyword.control-flow': {
    color: '#FF79C6', // Pink
  },
  function: {
    color: '#50FA7B', // Green
  },
  'function.maybe-class-name': {
    color: '#50FA7B', // Green
  },
  regex: {
    color: '#FFB86C', // Orange
  },
  important: {
    color: '#FF5555', // Red
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
  'class-name': {
    color: '#8BE9FD', // Cyan
  },
  'maybe-class-name': {
    color: '#8BE9FD', // Cyan
  },
  console: {
    color: '#8BE9FD', // Cyan
  },
  parameter: {
    color: '#FFB86C', // Orange
  },
  interpolation: {
    color: '#8BE9FD', // Cyan
  },
  'punctuation.interpolation-punctuation': {
    color: '#FF79C6', // Pink
  },
  variable: {
    color: '#BD93F9', // Purple for variables
  },
  'imports.maybe-class-name': {
    color: '#F8F8F2', // Soft white
  },
  'exports.maybe-class-name': {
    color: '#F8F8F2', // Soft white
  },
  escape: {
    color: '#F1FA8C', // Yellow
  },
  'tag.punctuation': {
    color: '#F8F8F2', // Soft white
  },
  cdata: {
    color: '#6272A4', // Muted purple/grey
  },
  'attr-value': {
    color: '#F1FA8C', // Yellow
  },
  'attr-value.punctuation': {
    color: '#F1FA8C', // Yellow
  },
  'attr-value.punctuation.attr-equals': {
    color: '#F8F8F2', // Soft white
  },
  namespace: {
    color: '#8BE9FD', // Cyan
  },
  // Language-specific overrides
  'pre[class*="language-javascript"]': {
    color: '#F8F8F2', // Base JS color
  },
  'code[class*="language-javascript"]': {
    color: '#F8F8F2',
  },
  'pre[class*="language-jsx"]': {
    color: '#F8F8F2',
  },
  'code[class*="language-jsx"]': {
    color: '#F8F8F2',
  },
  'pre[class*="language-typescript"]': {
    color: '#F8F8F2',
  },
  'code[class*="language-typescript"]': {
    color: '#F8F8F2',
  },
  'pre[class*="language-tsx"]': {
    color: '#F8F8F2',
  },
  'code[class*="language-tsx"]': {
    color: '#F8F8F2',
  },
  'pre[class*="language-css"]': {
    color: '#F1FA8C', // Default CSS text to yellow (strings)
  },
  'code[class*="language-css"]': {
    color: '#F1FA8C',
  },
  'pre[class*="language-html"]': {
    color: '#F8F8F2', // Base HTML color
  },
  'code[class*="language-html"]': {
    color: '#F8F8F2',
  },
  '.language-regex .token.anchor': {
    color: '#FF5555', // Red anchors in regex
  },
  '.line-highlight.line-highlight': {
    background: 'rgba(255, 255, 255, 0.08)', // Subtle line highlight
    boxShadow: 'inset 5px 0 0 #FF79C6', // Pink highlight indicator
    zIndex: '0',
  },
} as {
  [key: string]: React.CSSProperties;
};
